import { STRING, assert } from "./assert.js";
import { Error, HTMLScriptElement, isInstanceOf, parentElement } from "./index.js";
import { document, documentElement, getElementById } from "./window.js";
export function query(selectors, element) {
    return (element ?? document).querySelector(selectors);
}
export function queryAll(selectors, element) {
    return (element ?? document).querySelectorAll(selectors);
}
export const matches = (element, selectors) => element.matches(selectors);
export const closest = (target, selectors, callback, host = documentElement) => {
    while (target instanceof Node) {
        if (target instanceof HTMLElement) {
            if (matches(target, selectors)) {
                callback?.(target);
                return target;
            }
        }
        target = parentElement(target);
        if (target == host) {
            break;
        }
    }
    return null;
};
export const getScriptElement = (id) => {
    ASSERT: assert('getScriptElement id', id, STRING);
    const element = getElementById(id);
    if (!isInstanceOf(element, HTMLScriptElement)) {
        DEBUG: console.error(`getElementById("${id}") is not a HTMLScriptElement`);
        throw Error(id);
    }
    return element;
};
